import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	cancelImportModalTitle: {
		id: 'project-create-importer-upload-flow.cancel-import-modal.cancel-import-modal-title',
		defaultMessage: 'Are you sure you want to exit?',
		description: 'Modal header text when exiting an import',
	},
	cancelImportModalDescription: {
		id: 'project-create-importer-upload-flow.cancel-import-modal.cancel-import-modal-description',
		defaultMessage: "You'll lose any progress you’ve made with the import.",
		description: 'Modal body text when leaving an import',
	},
	continueImport: {
		id: 'project-create-importer-upload-flow.cancel-import-modal.continue-import',
		defaultMessage: 'Continue',
		description: 'Button text for continuing in import',
	},
	exitImport: {
		id: 'project-create-importer-upload-flow.cancel-import-modal.exit-import',
		defaultMessage: 'Exit',
		description: 'Button text for exiting import',
	},
});
